export default "__VITE_ASSET__a3617bf1__"